/* eslint-disable @next/next/no-img-element */
import ModalWrapper from "@/components/shared/ModalWrapper/ModalWrapper";
import styles from "./InniModal.module.css";
import CloseButtonSummary from "@/components/shared/CloseButtonSummary";
import { useModalContext } from "@/context/ModalContext";
import { openInNewTab } from "@/components/shared/utils";
import { Mixpanel } from "@/helpers/mixpanel";
import { useAuth } from "@/context/AuthContext";

export default function InniModal() {
  const { setModalOpen } = useModalContext();
  const {user} = useAuth()

  const handleClick = () => {
    Mixpanel?.track("INNI download CTA pressed", {
      source: "announcement modal"
    }, user?.uid)
    
    if (window.Android) {
      window.Android.openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni"
      );
    } else {
      openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni"
      );
    }
  };

  return (
    <ModalWrapper noHeader title="">
      <main className={styles.main}>
        <div onClick={() => setModalOpen(false)} className={styles.closeButton}>
          <CloseButtonSummary />
        </div>
        <img src="/inni/icon.png" alt="" className={styles.icon} />
        <h1 className={styles.title}>Introducing inni</h1>
        <h2 className={styles.subTitle}>
          {"Date people you're actually compatible with."}
        </h2>
        <button onClick={handleClick} className={styles.btn}>
          Download on the PlayStore
        </button>
        <h3
          style={{ marginTop: "14px", color: "#C0B9B7" }}
          className={styles.subTitle}
        >
          Built by <span style={{ color: "#FFFFF2" }}>Dimensional</span>
        </h3>
        <img className={styles.image} src="/inni/slideTwoImage.png" alt="" />
      </main>
    </ModalWrapper>
  );
}
